import type { TwiageCase } from "@/App/types/TwiageCase";
import { CaseType } from "@/App/types/caseType";
import { hasEmsAppUserLeftIftCase, isIftCaseClosed } from "@/Pages/Ift/components/IftCaseListStatus/IftStatusFunctions";

export const isClosedByEms = (twiageCase: TwiageCase): boolean => {
  return (
    (twiageCase.type !== CaseType.hospital && !!twiageCase?.arrivedAt) ||
    isIftCaseClosed(twiageCase) ||
    hasEmsAppUserLeftIftCase(twiageCase.ift)
  );
};
